@if (isLoading) {
  <loader [config]="loaderConfig"></loader>
}

<div class="container-fluid">
  <div class="row mb-3">
    <div class="col-12">
      <h2 class="mb-0">
        {{ isEditMode ? 'Update Complaint' : 'Create Complaint' }}
        @if (complaint?.code) {
          <span class="text-muted"> - {{ complaint.code }}</span>
        }
      </h2>
    </div>
  </div>


  <div class="row">
    <div class="col-md-12">
      <complaints-form
        [complaint]="complaint"
        [complaintId]="complaintId"
        [isEditPage]="isEditMode"
        [complaintStatus]="complaint?.status"
        (onSavedData)="onComplaintFormSavedData($event)"
        (onBack)="onBackClick()"
        (onSaveClick)="submitForm()"
        (onTakingCareChange)="onTakingCareChanged()" />
    </div>
  </div>

  @if (isEditMode && ((complaint?.takingCareUser || false) || hasMessages())) {
    <div class="row mt-3">
      <div class="col-md-12">
        <complaints-speech
          [complaintId]="complaintId"
          [complaint]="complaint"
          [isTakingCare]="!!complaint?.takingCareUser"
          [readonly]="complaint?.status === 'CLOSED'"
          (onStatusChange)="onComplaintSpeechStatusChange($event)" />
      </div>
    </div>
  }

  @if (isEditMode && canCloseComplaint && complaint?.status !== 'CLOSED' && !isCustomerProfile) {
    <div class="row mt-4">
      <div class="col-12">
        <div class="text-center">
          <button
            type="button"
            class="btn btn-outline-primary btn-lg px-5"
            (click)="confirmCloseComplaint()"> Close complaint
          </button>
        </div>
      </div>
    </div>
  }

  @if (isEditMode && complaintId && !isCustomerProfile) {
    <div class="row mt-4">
      <div class="col-12">
        <notes-customers-form
          [readonlyCustomerNotes]="complaint?.status === 'CLOSED'"
          [customer]="complaintNotes"
          [noteServiceMethod]="complaintsService"
          [addNoteMethod]="'createNotes'"
          [deleteNoteMethod]="'deleteNotes'"
          [sectionAttribute]="'complaintId'" />
      </div>
    </div>
  }
</div>

<ng-template #closeComplaintModalContent>
  <div class="modal-header">
    <h5 class="modal-title">Close complaint</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancelCloseComplaintDialog()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-3">Choose what kind of action will be taken Complaint monitoring</p>
    <select-field
      [selectFormControl]="monitorControl"
      [options]="monitorOptions"
      label="">
    </select-field>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancelCloseComplaintDialog()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="confirmCloseComplaintWithMonitor()">Save and close</button>
  </div>
</ng-template>
